import { render, staticRenderFns } from "./ServiceDashboard.vue?vue&type=template&id=29e5ee1d&"
import script from "./ServiceDashboard.vue?vue&type=script&lang=js&"
export * from "./ServiceDashboard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports